module.exports = __webpack_public_path__ + "static/media/7.dc0d62ed.jpg";